import { Flex } from "@instructure/ui";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";

const TITLE_HEIGHT = 60;
const TITLE_MARGIN = 25;
const SECTION_TITLE_HEIGHT = 50;
const SECTION_TITLE_MARGIN = 10;
const SECTION_DESCRIPTION_HEIGHT = 150;
const SECTION_DESCRIPTION_MARGIN = 10;

const ResultsSkeleton = () => {
  const [height, setHeight] = useState(window.innerHeight);

  const extraHeight =
    height -
    TITLE_HEIGHT -
    TITLE_MARGIN -
    2 * SECTION_TITLE_HEIGHT -
    2 * SECTION_TITLE_MARGIN -
    2 * SECTION_DESCRIPTION_HEIGHT -
    2 * SECTION_DESCRIPTION_MARGIN;

  const extraSkeletons = Math.floor(
    extraHeight /
      (SECTION_TITLE_HEIGHT +
        SECTION_DESCRIPTION_HEIGHT +
        SECTION_DESCRIPTION_MARGIN)
  );

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Flex wrap="wrap" gap="small">
      <Flex.Item size="100%">
        <Skeleton
          height={TITLE_HEIGHT}
          width="100%"
          style={{ maxWidth: 800, marginBottom: TITLE_MARGIN }}
        />
      </Flex.Item>
      <Flex.Item size="100%">
        <Skeleton
          height={SECTION_TITLE_HEIGHT}
          width="100%"
          style={{ maxWidth: 500, marginBottom: SECTION_TITLE_MARGIN }}
        />
        <Skeleton
          height={SECTION_DESCRIPTION_HEIGHT}
          width="100%"
          style={{ marginBottom: SECTION_DESCRIPTION_MARGIN }}
        />
      </Flex.Item>
      <Flex.Item size="100%">
        <Skeleton
          height={SECTION_TITLE_HEIGHT}
          width="100%"
          style={{ maxWidth: 500, marginBottom: SECTION_TITLE_MARGIN }}
        />
        <Skeleton
          height={SECTION_DESCRIPTION_HEIGHT}
          width="100%"
          style={{ marginBottom: SECTION_DESCRIPTION_MARGIN }}
        />
      </Flex.Item>
      {Array.from({ length: extraSkeletons }, (_, i) => (
        <Flex.Item key={i} size="100%">
          <Skeleton
            height={SECTION_TITLE_HEIGHT}
            width="100%"
            style={{ maxWidth: 500, marginBottom: SECTION_TITLE_MARGIN }}
          />
          <Skeleton
            height={SECTION_DESCRIPTION_HEIGHT}
            width="100%"
            style={{ marginBottom: SECTION_DESCRIPTION_MARGIN }}
          />
        </Flex.Item>
      ))}
    </Flex>
  );
};

export default ResultsSkeleton;
